import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Picker } from '@react-native-picker/picker';
import { useTheme } from '../../theme/useTheme';
import { EDUCATION_LEVELS } from '../../utils/profileConstants';

const BasicInfoForm = ({
  membershipStatus,
  educationLevel,
  onMembershipChange,
  onEducationChange,
  errors = {}
}) => {
  const { colors, borderRadius } = useTheme();

  return (
    <View style={styles.container}>
      <View style={styles.pickerField}>
        <Text style={styles.label}>Membership Status</Text>
        <View style={[styles.pickerWrapper, { borderRadius: borderRadius.md }]}>
          <Picker
            selectedValue={membershipStatus}
            onValueChange={onMembershipChange}
            style={styles.picker}
            dropdownIconColor={colors.primary.main}
          >
            <Picker.Item label="Active Member" value="active" />
            <Picker.Item label="Alumni" value="alumni" />
          </Picker>
        </View>
      </View>

      <View style={styles.pickerField}>
        <Text style={styles.label}>Education Level</Text>
        <View style={[styles.pickerWrapper, { borderRadius: borderRadius.md }]}>
          <Picker
            selectedValue={educationLevel}
            onValueChange={onEducationChange}
            style={styles.picker}
            mode="dropdown"
            dropdownIconColor={colors.primary.main}
          >
            <Picker.Item label="Select Education Level" value="" style={{ color: colors.text.secondary }} />
            {EDUCATION_LEVELS.map((level) => (
              <Picker.Item key={level} label={level} value={level} />
            ))}
          </Picker>
        </View>
        {errors.educationLevel && <Text style={styles.errorText}>{errors.educationLevel}</Text>}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    paddingVertical: 8,
  },
  pickerField: {
    marginBottom: 12,
  },
  label: {
    fontSize: 12,
    marginBottom: 6,
    color: '#64748B',
    fontWeight: '600',
    marginLeft: 2,
  },
  pickerWrapper: {
    backgroundColor: '#F8FAFC',
    borderWidth: 1.2,
    borderColor: '#EDF2F7',
    overflow: 'hidden',
  },
  picker: {
    height: 44,
    width: '100%',
    color: '#1E293B',
  },
  errorText: {
    color: '#EF4444',
    fontSize: 11,
    marginTop: 4,
    marginLeft: 4,
    fontWeight: '500',
  },
});

export default BasicInfoForm;
